module.exports = __webpack_public_path__ + "static/media/mulher_r2_c9.d3987ac2.jpg";